import React, { useState, useEffect } from 'react';
import { Modal, Checkbox, Button, Divider, Icon } from 'selfly-ui-react';
import _ from 'lodash';

const alarmColors = {
    OoS: '#9599A3',
    Urgent: 'red',
    Critical: 'orange',
    Informative: 'yellow'
};
const AlarmInfoModal = ({ isAlarmInfoModalOpen, alarmInfoModalClose, activeCategory, alertTypes, alertTypesChange }) => {
    const [selectedAlertTypes, setSelectedAlertTypes] = useState([]);
    const [selectAll, setSelectAll] = useState('custom');

    useEffect(() => {
        setSelectedAlertTypes([...alertTypes]);
    }, []);

    const onAlertTypeChange = (event, type) => {
        if (event.target.checked) {
            const selectedTypes = [...selectedAlertTypes, type];
            setSelectedAlertTypes(selectedTypes);
        } else {
            const selectedTypes = [...selectedAlertTypes];
            const currentSelection = selectedTypes.find(
                selected => selected.severity.toLowerCase() === type.severity.toLowerCase() && selected.type.toLowerCase() === type.type.toLowerCase()
            );
            const index = selectedTypes.indexOf(currentSelection);
            if (index !== -1) {
                selectedTypes.splice(index, 1);
            }
            setSelectedAlertTypes(selectedTypes);
        }
    };

    useEffect(() => {
        alertTypesChange(selectedAlertTypes);
        if (selectedAlertTypes.length === 0) {
            setSelectAll('none');
        } else if (selectedAlertTypes.length === activeCategory.types.length) {
            setSelectAll('all');
        } else {
            setSelectAll('custom');
        }
    }, [selectedAlertTypes]);

    const toggleSelection = condition => {
        const selectedTypes = [...selectedAlertTypes];
        const allFromSelectedCategory = activeCategory.types.map(type => {
            return { type: type.type, severity: type.severity };
        });
        if (condition === 'all') {
            const onlyUnique = _.unionWith(selectedTypes, allFromSelectedCategory, _.isEqual);
            setSelectedAlertTypes(onlyUnique);
        }
        if (condition === 'none') {
            const diffenence = _.differenceWith(selectedTypes, allFromSelectedCategory, _.isEqual);
            setSelectedAlertTypes(diffenence);
        }
    };

    return (
        <Modal onClose={alarmInfoModalClose} title={activeCategory.name} active={isAlarmInfoModalOpen}>
            <div className="alarm-modal">
                <p>Subscribe to the following errors or incidents to which you would like to receive alarms for</p>
                <div className="alarm-modal__select">
                    <span className="alarm-modal__label">Select</span>
                    <span
                        className={`alarm-modal__option ${selectAll === 'all' ? 'alarm-modal__option--selected' : ''}`}
                        onClick={() => {
                            toggleSelection('all');
                        }}>
                        All
                    </span>{' '}
                    /
                    <span
                        className={`alarm-modal__option ${selectAll === 'none' ? 'alarm-modal__option--selected' : ''}`}
                        onClick={() => {
                            toggleSelection('none');
                        }}>
                        None
                    </span>
                </div>
                <ul>
                    {activeCategory.types.map(type => {
                        return (
                            <li key={type.label}>
                                <Checkbox
                                    id={type.label}
                                    size="sm"
                                    checked={selectedAlertTypes.find(
                                        selected =>
                                            type.type.toLowerCase() === selected.type.toLowerCase() &&
                                            selected.severity.toLowerCase() === type.severity.toLowerCase()
                                    )}
                                    onChange={event => onAlertTypeChange(event, { type: type.type, severity: type.severity })}>
                                    {type.label}<Icon size='sm' style={{marginLeft: '8px', color: alarmColors[type.severity] ? alarmColors[type.severity] : 'gray'}}>brightness_1</Icon> 
                                </Checkbox>
                            </li>
                        );
                    })}
                </ul>
                <Divider />
                <div className="alarm-modal__button">
                    <Button size="sm" onClick={alarmInfoModalClose}>
                        Ok
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export const DeletePermissionModal = ({ confirmationOpen, deleteForever, message }) => {
    return (
        <Modal active={confirmationOpen} title="Delete confirmation" onClose={() => deleteForever(false)}>
            <div className="alarm-modal">
                <h3>Are you sure you want to delete it?</h3>

                <div className="alarm-modal-warn">{message}</div>

                <Divider />
                <div className="alarm-modal__button">
                    <Button size="md" onClick={() => deleteForever(false)} icon="close">
                        NO
                    </Button>
                    <Button size="md" type="negative" onClick={() => deleteForever(true)} icon="delete_forever">
                        YES
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default AlarmInfoModal;
